import { useEffect, useState } from "react";

const fetchUsersData = async () => {
  const data = await fetch("https://jsonplaceholder.typicode.com/users");
  const body = data.json();

  if (!data.ok) {
    throw new Error(data.statusText);
  }

  return body;
};

export default function LoadMoreApiData() {
  const [usersData, setUsersData] = useState([]);
  const [counter, setCounter] = useState(5);
  const incrementCounterValue = () => {
    if (counter < usersData.length) {
      setCounter(counter + 5);
    } else {
      setCounter(5);
    }
  };

  useEffect(() => {
    const getUsersData = async () => {
      const res = await fetchUsersData();
      setUsersData(res);
    };

    getUsersData();
  }, []);

  return (
    <div>
      <h3>Daftar Data Pengguna</h3>
      <ul>
        {usersData.length !== 0 ? (
          usersData
            .slice(0, counter)
            .map((user) => <li key={user.id}>{user.name}</li>)
        ) : (
          <p>Tidak ada data pengguna tersedia.</p>
        )}
      </ul>
      <button disabled={usersData.length === 0} onClick={incrementCounterValue}>
        {counter === usersData.length ? "Show Less" : "Load More"}
      </button>
    </div>
  );
}
